import type { TextBlock } from '../interfaces/textEditor.interface';

const SNIPPET_MAX = 80;

/**
 * Derives a human-readable title for a post from its text blocks:
 * first non-empty Heading → first non-empty Paragraph snippet → fallback.
 */
export function derivePostTitle(
  blocks: TextBlock[] | null | undefined,
): string {
  if (!blocks || blocks.length === 0) return 'Untitled story';

  const heading = blocks.find(
    (b) => b.type === 'Heading' && (b.data?.header ?? '').trim().length > 0,
  );
  if (heading?.data?.header) return heading.data.header.trim();

  const paragraph = blocks.find(
    (b) =>
      b.type === 'Paragraph' && (b.data?.paragraph ?? '').trim().length > 0,
  );
  if (paragraph?.data?.paragraph) {
    const text = paragraph.data.paragraph.trim();
    return text.length > SNIPPET_MAX ? `${text.slice(0, SNIPPET_MAX)}…` : text;
  }

  return 'Untitled story';
}
